import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import qs from 'qs'

const customHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'cache-control': 'no-cache'
};

const randomStringGen = () => {
    let result = ""
    let randomString = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890"
    for (var i = 0; i < randomString.length; i += 1) {
        result += randomString.charAt(Math.floor(Math.random() * randomString.length));
    }
    return result
}

const getAccessToken = async () => {
    let accessString = randomStringGen()
    let token = await axios.post(`https://restapi-pluto.herokuapp.com/fetch`, qs.stringify({
        accessId: accessString
    }), customHeaders)
    return token.data.accessToken;
}

const postHandler = async (url, payload) => {

    var data;
    let gettoken = await getAccessToken()

    try {
        let dump = await axios.post(url, qs.stringify(
            payload
        ), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'cache-control': 'no-cache',
                'authorization': `Bearer ${gettoken}`
            },
        })
        data = await dump.data
    } catch (error) {
        toast.error('error', error)
    }

    return data
}

const Emoji = props => (
  <span
      className="emoji"
      role="img"
      aria-label={props.label ? props.label : ""}
      aria-hidden={props.label ? "false" : "true"}
  >
      {props.symbol}
  </span>
);

function JoinTeams(props) {

  const [userEmail, setUserEmail] = useState('')
  const [notJoined, setIsJoined] = useState(true);

  useEffect(() => {
    toast.success("Welcome to Pluto Office 🚀")
   
  }, [])

  return (
    <div className="App">
      <ToastContainer 
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <header className="App-header">
        <h2>
        Welcome to Pluto Office 
          <Emoji symbol="🚀"/>
        </h2>
        <h5>
        Join your team
           <Emoji symbol=" 😎"/>
        </h5>
      <TextField 
        autoFocus
        type='text' 
        value={userEmail} 
        onChange={e => setUserEmail(e.target.value)} 
        required
        id="outlined-required-roomname"
        label="Your Gmail"
        placeholder="Your Gmail"
        variant="outlined"
      />
      <hr />
              {
                notJoined ? 
                <Button 
                variant="outlined" 
                color="secondary" 
                size="large"
                onClick={ async () => {
                    if(userEmail.search("gmail.com") < 0 || userEmail === "") {
                      toast.error("Enter Valid Gmail Email")
                    } else {
                      setIsJoined(false)
                      toast.success("Connecting to Pluto Server...")
                      let res = await postHandler(`https://restapi-pluto.herokuapp.com/bymglnk/${props.id}`, {
                          email : userEmail
                      })
                      toast.success(res.data.message)
                    }
                  }}
                > Join Team <Emoji symbol=" 👍"/> 
                </Button> : 
                <Button
                  variant="outlined" 
                  color="primary" 
                  size="large"
                  onClick={() => {
                    toast.success("No Downloads Yet 😢")
                  }}
                >
                  Downlaod Pluto <Emoji symbol=" ❤️"/>                  
                </Button>
              }
              <hr />
              <code>Team Magic Id : {props.id}</code>
      </header>
    </div>
  );
}

export default JoinTeams;
